var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    width: "40px",
    height: "40px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.9 2 10 2.9 10 4L7 4C5.35 4 4 5.35 4 7L4 14L46 14L46 7C46 5.35 44.65 4 43 4L40 4C40 2.9 39.1 2 38 2L32 2C30.9 2 30 2.9 30 4L21 4C21 2.9 20.1 2 19 2L12 2 z M 10 7C11.1 7 12 7.9 12 9C12 10.1 11.1 11 10 11C8.9 11 8 10.1 8 9C8 7.9 8.9 7 10 7 z M 16 7C17.1 7 18 7.9 18 9C18 10.1 17.1 11 16 11C14.9 11 14 10.1 14 9C14 7.9 14.9 7 16 7 z M 22 7C23.1 7 24 7.9 24 9C24 10.1 23.1 11 22 11C20.9 11 20 10.1 20 9C20 7.9 20.9 7 22 7 z M 28 7C29.1 7 30 7.9 30 9C30 10.1 29.1 11 28 11C26.9 11 26 10.1 26 9C26 7.9 26.9 7 28 7 z M 40 7C41.1 7 42 7.9 42 9C42 10.1 41.1 11 40 11C38.9 11 38 10.1 38 9C38 7.9 38.9 7 40 7 z M 4 16L4 42C4 43.65 5.35 45 7 45L9 45L9 46C9 47.1 9.9 48 11 48L14 48C15.1 48 16 47.1 16 46L16 45L34 45L34 46C34 47.1 34.9 48 36 48L39 48C40.1 48 41 47.1 41 46L41 45L43 45C44.65 45 46 43.65 46 42L46 16L4 16 z M 10 21L40 21L40 39L10 39L10 21 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOven);
export default __webpack_public_path__ + "static/media/oven.b135e25e6ba29d51f37ae7a6800bb4ee.svg";
export { ForwardRef as ReactComponent };